const outOfRegionPageTranslations = {
  title: "غير متاح في منطقتك",
  descriptionLine1: "لديك اشتراك محلي ولكنك تحاول حالياً الدخول إلى البوابة من خارج مصر.",
  descriptionLine2: "هذا النوع من الاشتراك مقتصر على الاستخدام المحلي فقط.",
  button: "العودة لتسجيل الدخول",
};

export default outOfRegionPageTranslations;
